module.exports = __webpack_public_path__ + "static/media/30.cec9e78a.gif";